export const STAT_ICON_SRC = {
  progress: "/icon-progress.svg",
  deadline: "/icon-deadline.svg",
  fatigue: "/icon-fatigue.svg",
  block: "/icon-block.svg",
  action: "/icon-action.svg",
} as const;

export type StatIconName = keyof typeof STAT_ICON_SRC;

const WIDE_ICONS = new Set<StatIconName>(["fatigue", "block"]);

export function StatIcon({ name }: { name: StatIconName }) {
  const className = WIDE_ICONS.has(name) ? "stat-icon is-wide" : "stat-icon";
  return <img className={className} src={STAT_ICON_SRC[name]} alt="" draggable={false} />;
}
